import { type HTMLAttributes, type PropsWithChildren, useEffect } from "react";
import { type IntersectionOptions, useInView } from "react-intersection-observer";

import { type ITelemetryCustom, sendTelemetryEvent } from "@/lib/telemetry";
import type { OmitStyles, PropsWithStyleX } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

interface ITelemetryHOC
    extends PropsWithChildren<PropsWithStyleX>, OmitStyles<HTMLAttributes<HTMLDivElement>> {
    options?: IntersectionOptions;
    telemetryCustom: ITelemetryCustom;
}

export default function TelemetryHoc({ options, telemetryCustom, children, styleX, ...all }: ITelemetryHOC) {
    const initialOptions: IntersectionOptions = options || {
        triggerOnce: true,
        threshold: 0.15,
    };

    const { ref, inView } = useInView(initialOptions);

    useEffect(() => {
        if (inView) {
            sendTelemetryEvent(telemetryCustom);
        }
    }, [inView, telemetryCustom]);

    return (
        <div {...all} ref={ref} {...stylex.props(styleX)}>
            {children}
        </div>
    );
}
